import AnimateObject from 'epic-fortnite-react/components/common/AnimateObject';
import React from 'react';

import {CrewLeaf} from '../../../icons';
import CommonCTABtn from '../../common/CommonCTABtn';

import {CrewCTAContainer} from './components';

interface Cta {
  isCtaLinkExternal: boolean;
  textOnly: boolean;
  ctaString: string;
  disabled: boolean;
}

interface Props {
  cta: Cta;
}
const CrewCTA = ({cta}: Props) => {
  return (
    <CrewCTAContainer>
      <AnimateObject
        minTop={20}
        speed={1.5}
        from={{y: `+=50`, autoAlpha: 0}}
        to={{y: 0, autoAlpha: 1, delay: 0.5}}>
        <>
          <CommonCTABtn
            id="battlePass-crew-learnMore"
            className="btn-hover-transform crew-button"
            ctaConfig={cta}
          />
          <CrewLeaf id="left" />
          <CrewLeaf id="right" />
        </>
      </AnimateObject>
    </CrewCTAContainer>
  );
};

export default CrewCTA;
